/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const customerAssignmentRemoveBodyExpectedCustomerVersionExclusiveMin = 0;
export const customerAssignmentRemoveBodyExpectedCustomerVersionMax = 9007199254740991;

export const CustomerAssignmentRemoveBody = zod.object({
  expectedCustomerVersion: zod
    .int()
    .gt(customerAssignmentRemoveBodyExpectedCustomerVersionExclusiveMin)
    .max(customerAssignmentRemoveBodyExpectedCustomerVersionMax),
});

export type CustomerAssignmentRemoveBody = zod.input<typeof CustomerAssignmentRemoveBody>;
export type CustomerAssignmentRemoveBodyOutput = zod.output<typeof CustomerAssignmentRemoveBody>;
